<template>
  <div class="bg">
    <a-card :title="$t('edit.editActionTitles.pwdSets')" :bordered="false">
      <a-row>
        <a-col :span="8">
          <a-form-model layout="vertical" ref="ruleForm" :form="form" :model="form">
            <a-form-model-item has-feedback :label="$t('login.password')">
              <a-input v-model="form.pwd" :placeholder="$t('message.pwdErr')" />
            </a-form-model-item>
            <a-form-model-item>
              <a-button type="primary" @click="handleSubmit">{{$t('actionTitles.submit')}}</a-button>
              <a-button style="margin-left: 10px;" @click="handleCancel">{{$t('actionTitles.cancel')}}</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: { ...mapGetters(["vrbase", "userInfo"]) },
  data() {
    return {
      form: {
        pwd: "",
      },
    };
  },
  created() {
    this.form.pwd = this.vrbase.sets.view_passwd;
  },
  methods: {
    handleSubmit() {
      const vrbase = {
          ...this.vrbase,
          sets: { ...this.vrbase.sets, view_passwd: this.form.pwd },
        }
      this.$store
        .dispatch("saveVRBase", { vrbase, showLoading: true, })
        .then(() => {
          // this.$message.success(this.$t("message.saveSuccess"));
        });
    },
    handleCancel() {
      this.form.pwd = this.vrbase.sets.view_passwd;
    },
  },
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  .submitBtn {
    background-color: #7101ad;
    border-color: #7101ad;
  }
}
</style>